/**
 * @generated SignedSource<<cbbeb417cb16f4e9067d623a99571c59>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksArticlePageAdvertisementConfigArticle$data = {
  readonly appConfig: {
    readonly json: unknown | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "hooksArticlePageAdvertisementConfigArticle";
};
export type hooksArticlePageAdvertisementConfigArticle$key = {
  readonly " $data"?: hooksArticlePageAdvertisementConfigArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"hooksArticlePageAdvertisementConfigArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "appConfigEntityId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "hooksArticlePageAdvertisementConfigArticle",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "entityId",
              "variableName": "appConfigEntityId"
            }
          ],
          "kind": "ObjectValue",
          "name": "filter"
        }
      ],
      "concreteType": "AppConfigs",
      "kind": "LinkedField",
      "name": "appConfig",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "json",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "424e6318ecff0c62532b346874305fdd";

export default node;
